import { useState } from "react";
import Input from "../../../design/Input";
import { GrAdd } from "react-icons/gr";
import TableDatalis from "./TableDatalis";
import regx from "../../../../functions/regx";


export default function Note ({data, setData}) {
    const templateNote = {dataNote: "", num: 0};
    const [note, setNote] = useState(templateNote);
    const head = ["מס'", "הערה", "", ""];

    function insertNote () {
        if (regx(/^[a-zA-Zא-ת ']{1,100}$/, note.dataNote, false)) {
            let num;
            if (note.num === 0) {
                let keys = Object.keys(data.note);
                num = (keys.length ? Math.max(...keys) : 0) + 1
            } else {
                num = note.num;
            }
            let newNote = {...data.note, [num]: note};
            setData({...data, note: newNote});
            setNote(templateNote);
        }
    }

    return (
    <>
        <div className="NoteOtherDatalis">
            <Input 
            myStyle='input2' 
            textView={'הוסף הערה'} 
            value={note.dataNote} 
            onChange={(value) => setNote({...note, dataNote: value})} 
            pattern={/^[a-zA-Zא-ת ']{1,100}$/} 
            />
            <GrAdd className="NoteOtherDatalisIcon" onClick={() => insertNote()} />
        </div>

        <TableDatalis 
        name={'note'} 
        head={head} 
        data={data.note}
        edit={(value) => setNote({...data.note[value], num: value})} 
        myDelete={(value) => {
            let note = data.note;
            delete note[value];
            setData({...data, note: {...note}});
        }}
        />
    </>
    )
}